import fireAnalytics from '~/services/analytics/fireAnalytics';
import { RailsSwapDetail } from '~/typings/services/rails/swaps';
import { AnalyticsSource } from '~/services/analytics/AnalyticsInterfaces';

export const fireVisitedSwaps = (type: 'search' | string, scope?: string) =>
  fireAnalytics('Visited Swaps', null, {
    type,
    folder: scope,
  });

export const fireVisitedSwap = (
  swapDetails: RailsSwapDetail,
  role?: 'buyer' | 'seller',
) =>
  fireAnalytics('Visited Swap', null, {
    role,
    swap_id: swapDetails.id,
  });

export const fireSentMessage = (
  swapDetails?: RailsSwapDetail,
  role?: 'buyer' | 'seller',
  src?: AnalyticsSource,
) =>
  fireAnalytics('Sent Message', src, {
    role,
    swap_id: swapDetails?.id,
  });

export const fireOpenedDispute = (swapDetails: RailsSwapDetail) =>
  fireAnalytics('Opened Dispute', null, { swap_id: swapDetails.id });

interface SwapMessageAnalyticsParams {
  url: string;
  swap_id: number;
}

export const clickedSwapMessage = (params: SwapMessageAnalyticsParams) =>
  fireAnalytics('Clicked Swap Message', null, params);

export const visitedExternalLinkWarning = (params: SwapMessageAnalyticsParams) =>
  fireAnalytics('Visited External Link Warning', null, params);

export const clickedExternalLink = (params: SwapMessageAnalyticsParams) =>
  fireAnalytics('Clicked External Link', null, params);
